<template>
  <el-drawer
    :visible.sync="visible"
    :direction="direction"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :before-close="close"
    size="70%"
    @open="getDetail"
    withHeader="false"
  >
    <div slot="title">订单编号【{{ info.orderNo }}】</div>
    <div class="margin-left-15">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="flex flex-justify-between">
            <div style="overflow: auto; max-width: 75%">
              <el-steps align-center process-status="finish" finish-status="success" :space="500">
                <el-step
                  v-for="(item, index) of info.timePointsVos"
                  :key="index"
                  :title="item.operate"
                  :description="item.timePoint"
                />
              </el-steps>
            </div>
            <div class="margin-right-40">
              <el-button
                v-if="[2, 4, 7].includes(info.state)"
                type="danger"
                size="mini"
                @click="handleFinish"
                >完成订单</el-button
              >
              <el-button
                v-if="[2, 4, 5, 7].includes(info.state)"
                type="danger"
                size="mini"
                @click="handleChange"
                >改签</el-button
              >
              <el-button
                v-if="[2, 4, 5, 6, 7, 8].includes(info.state) && info.surplusAmount"
                type="primary"
                size="mini"
                @click="handleRefund"
              >
                退款
              </el-button>
            </div>
          </div>
          <el-menu
            class="margin-left-10"
            :default-active="activeStep"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item v-for="(item, index) in tabMapOptions" :key="index" :index="item.key"
              >{{ item.label }}
            </el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="24" class="scroll_cls" @scroll="onScroll">
          <div class="title-box scroll-item margin-y-10">基础信息</div>
          <base-info :info="info" />
          <div class="title-box scroll-item margin-y-10">货运信息</div>
          <goodsInfo :expressOrderDetails="info.expressOrderDetails" />
          <div class="title-box scroll-item margin-y-10">行程信息</div>
          <el-descriptions :column="2">
            <el-descriptions-item label="寄件详细地址">
              <div style="max-width: 350px">
                <yd-link
                  :value="info.departureAddress"
                  type="location"
                  :query="{
                    longitude: info.departureLongitude,
                    latitude: info.departureLatitude,
                    name: info.departureAddress,
                    lineName: info.lineName
                  }"
                />
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="取件详细地址">
              <div style="max-width: 350px">
                <yd-link
                  :value="info.destinationAddress"
                  type="location"
                  :query="{
                    longitude: info.destinationLongitude,
                    latitude: info.destinationLatitude,
                    name: info.destinationAddress,
                    lineName: info.lineName
                  }"
                />
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="寄件人信息">
              <yd-link
                v-if="userList.includes(info.senderMobilePhone)"
                permi="user_center_manage"
                :value="info.senderName + info.senderMobilePhone"
                :url="phoneUrl(info, info.senderMobilePhone)"
                type="userInfo"
              />
              <span v-else>{{ info.senderName }} {{ info.senderMobilePhone }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="收件人信息">
              <yd-link
                v-if="userList.includes(info.recipientMobilePhone)"
                permi="user_center_manage"
                :value="info.recipientName + info.recipientMobilePhone"
                :url="phoneUrl(info, info.recipientMobilePhone)"
                type="userInfo"
              />
              <span v-else>{{ info.recipientName }} {{ info.recipientMobilePhone }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="出发时间">{{ info.flightPlanTime }}</el-descriptions-item>
            <el-descriptions-item label="公里数">{{ info.mileage }}</el-descriptions-item>
          </el-descriptions>
          <div class="title-box scroll-item margin-y-10">车次信息</div>
          <trainsInfo :trainsInfo="info.trainsInfoVO" />
          <div class="title-box scroll-item margin-y-10">交易信息</div>
          <div class="font-14 margin-x-20">
            <span class="margin-right-10">已付金额：{{ info.paySuccessAmount }}</span>
            <span class="margin-right-10">已退金额：{{ info.refundSuccessAmount }}</span>
            <span class="margin-right-10">订单剩余金额：{{ info.surplusAmount }}</span>
          </div>
          <transactionInfo :info="info" />
          <div class="title-box scroll-item margin-y-10">优惠券套餐</div>
          <div class="font-14 margin-x-20">
            <span class="margin-right-10">套餐名称：--</span>
            <span class="margin-right-10">售价：0元</span>
          </div>
          <el-table :data="info.coupon" border size="mini" max-height="350px">
            <el-table-column prop="type" label="优惠券名称" align="center" />
            <el-table-column prop="ydTrxId" label="优惠券金额" align="center" />
            <el-table-column prop="trxId" label="数量" align="center" width="100" />
            <el-table-column prop="detail" label="有效期" align="center" />
          </el-table>
          <div class="scroll-item">
            <el-button
              style="margin: 20px 0 12px 12px"
              @click="showLogData"
              :loading="logLoading"
              size="small"
              type="primary"
              >操作日志
              <i class="el-icon-arrow-right" v-if="!showLog"></i>
              <i class="el-icon-arrow-down" v-else></i>
            </el-button>
            <div class="log-table">
              <transition name="el-fade-in-linear">
                <logInfo :logList="logList" v-show="showLog" />
              </transition>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <refundInfo />
    <changeOrder v-if="changeShow" />
  </el-drawer>
</template>

<script >
import { nextTick, onMounted, computed } from '@vue/composition-api';
import _enum from '../hooks/enum';
import useDetail from '../hooks/use-detail';
import baseInfo from './base-info.vue';
import goodsInfo from './goods-info.vue';
import trainsInfo from './trains-info.vue';
import transactionInfo from './transaction-info.vue';
import logInfo from './log-info.vue';
import refundInfo from './refund-info.vue';
import changeOrder from './change-order.vue';
import { phoneUrl } from '@/views/order/intercity/utils';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const {
    tabMapOptions
  } = _enum();
  const {
    info,
    visible,
    activeStep,
    handleSelect,
    onScroll,
    handleRefund,
    handleChange,
    changeShow,
    handleFinish,
    showLogData,
    logLoading,
    showLog,
    logList,
    close,
    getDetail
  } = useDetail();
  onMounted(() => {
    nextTick(() => {
      window.addEventListener('scroll', onScroll, true);
    });
  });
  const userList = computed(() => {
    const {
      userMap
    } = info.value || {};
    return Object.keys(userMap || {}) || [];
  });
  return {
    phoneUrl,
    tabMapOptions,
    info,
    visible,
    activeStep,
    handleSelect,
    onScroll,
    handleRefund,
    handleChange,
    changeShow,
    handleFinish,
    showLogData,
    logLoading,
    showLog,
    logList,
    close,
    getDetail,
    userList
  };
};
__sfc_main.components = Object.assign({
  baseInfo,
  goodsInfo,
  trainsInfo,
  transactionInfo,
  logInfo,
  refundInfo,
  changeOrder
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .title-box {
    margin-left: 5px;
    display: flex;
    font-size: 16px;
    font-weight: 600;
  }

  .scroll_cls {
    height: 75vh;
    overflow: auto;
  }
  ::v-deep.el-step {
    min-width: 120px;
  }
  ::v-deep .el-drawer__header {
    padding: 10px 20px 0;
    margin-bottom: 10px;
  }

  ::v-deep .el-step__title {
    // white-space: nowrap;
    font-size: 14px;
    line-height: 16px;
    margin: 10px 0;
  }

  ::v-deep .el-steps--horizontal {
    margin-left: 20px;
    padding: 0 10px;
  }

  ::v-deep .el-step__main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>
